import { render, staticRenderFns } from "./postSelect.vue?vue&type=template&id=eab3e4d0&"
import script from "./postSelect.vue?vue&type=script&lang=js&"
export * from "./postSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports